export default {
	CPU: 'CPU',
	IP: 'IP',
	vps_console: {
		IP: 'IP',
		IPv4: 'IPv4',
		network_table: {
			'30_day': 'Last 30 days',
			'7_day': 'Last 7 days',
			to_day: 'Today',
			to_month: 'Last month',
		},
		'1个月': '1 month',
		'1年': '1 year',
		'1小时': '1 hour',
		'24小时': '24 hours',
		'7天': '7 days',
		百分比: 'Percent',
		包转发率: 'Packet rate',
		本月: 'Last month',
		操作日志: 'Operation log',
		操作系统: 'OS',
		操作已取消: 'Operation cancelled',
		出带宽: 'Outbound',
		出站: 'Out',
		创建时间: 'Created',
		磁盘名称: 'Disk name',
		磁盘信息: 'Disks',
		等待重启: 'Waiting for reboot',
		读取速度: 'Read speed',
		读取IOPS: 'Read IOPS',
		断电关机: 'Force off',
		发送流量: 'Sent',
		分钟: 'Minutes',
		复制: 'Copy',
		概览: 'Overview',
		概要: 'Overview',
		格式化数据盘: 'Format data disk',
		挂载: 'Mount',
		关机: 'Shut down',
		将重建至: 'Rebuild to',
		接收流量: 'Received',
		结束时间: 'End time',
		今日: 'Today',
		近7天: 'Last 7 days',
		进带宽: 'Inbound',
		进度: 'Progress',
		敬请期待: 'Coming soon',
		开机: 'Power on',
		开始时间: 'Start time',
		控制台: 'Console',
		类型: 'Type',
		类型大小: 'Type / size',
		流出: 'Out',
		流出流量: 'Outbound',
		流量: 'Traffic',
		流量计费统计: 'Traffic usage',
		流入: 'In',
		流入流量: 'Inbound',
		秒: 'Seconds',
		内存用量: 'Memory usage',
		平均流量: 'Avg',
		'请求超时，请稍后刷新页面查看': 'Request timed out. Please refresh the page later.',
		请输入端口: 'Please enter port',
		请输入密码: 'Please enter password',
		请先确认数据已完成备份: 'Please confirm the data is backed up first',
		请选择操作系统: 'Please select an OS',
		确定要断电关机吗: 'Confirm to force off?',
		确定要关机吗: 'Confirm to shut down?',
		确定要重启吗: 'Confirm to reboot?',
		任务: 'Tasks',
		任务类型: 'Type',
		任务描述: 'Description',
		入站: 'In',
		实例ID: 'Instance ID',
		随机生成: 'Generate randomly',
		天: 'Days',
		图表: 'Charts',
		网卡: 'Network',
		我确认数据已完成备份: 'I confirm the data is backed up',
		系统重装中: 'Reinstalling, please refresh the page later to view the result',
		小时: 'Hours',
		写入速度: 'Write speed',
		写入IOPS: 'Write IOPS',
		已持续运行: 'Running',
		已关机: 'Shut down',
		已用: 'Used',
		硬盘IO: 'Disk I/O',
		硬重启: 'Hard reboot',
		用户名密码: 'Username / password',
		用量排行: 'Top usage',
		远程: 'Remote',
		运行中: 'Running',
		正在重置密码: 'Resetting password',
		正在重装: 'Reinstalling',
		执行中: 'Executing',
		重建实例: 'Rebuild instance',
		重建实例警告: 'Rebuilding will erase all personal data. Please make sure you have completed a backup. Are you sure to rebuild this instance?',
		重启: 'Reboot',
		重置密码: 'Reset password',
		重装: 'Reinstall',
		重装系统将会导致系统盘数据丢失: 'Reinstalling will erase all data on the system disk. Confirm to reinstall?',
		重装系统确认: 'Reinstall confirmation',
		主: 'Primary',
		主机名: 'Hostname',
		总计流量: 'Total',
		总量: 'Total',
		总流量: 'Total traffic',
		最大流量: 'Max',
		最新流量: 'Latest',
		CPU使用量: 'CPU usage',
		IP地址: 'IP address',
		SSH端口: 'SSH port',
	},
	备注: 'Notes',
	本订单已有未处理的关闭申请工单号: 'This order already has a pending close request <strong>{no}</strong>',
	本订单已有未处理的售后工单工单号: 'This order already has a pending after-sale ticket <strong>{no}</strong>',
	操作: 'Actions',
	操作系统: 'OS',
	产品: 'Product',
	产品到期不续费: '(The product has been set to not renew at expiration, and the product will be automatically canceled after expiration.)',
	产品到期续费: '(Manual renewal is allowed, and a renewal bill will be automatically generated before expiration.)',
	产品价格: 'Product price',
	产品配置: 'Configure product',
	产品信息: 'Product details',
	产品选择: 'Choose product',
	带宽: 'Bandwidth',
	单价: 'Unit price',
	到期不续费: 'Not renew at expiration',
	到期日期: 'Due date',
	登录信息: 'Login details',
	订单: 'Order',
	订单编号: 'Order No.',
	订单编号将于多少时间后关闭: 'Order {no} will close in {time}',
	订单管理: 'Orders',
	订单类型: 'Order type',
	订单信息: 'Order details',
	订单支付成功后将续费至日期: 'After payment, this order will be renewed to <strong>{date}</strong>',
	端口: 'Port',
	发票信息: 'Invoices',
	返回: 'Back',
	'服务器/cpu': 'Server / CPU',
	附加IP地址: 'Additional IPs',
	复制: 'Copy',
	复制信息: 'Copy details',
	该产品需要实名认证达标后购买: 'This product requires your identity verification to meet the required level before purchase',
	个: '',
	更多: 'More',
	购买物理机: 'Buy dedicated server',
	购买云主机: 'Buy VPS',
	关闭订单: 'Close order',
	关闭订单标题: 'Close order {no}',
	关闭订单内容: 'Submitted close request for order {no}, product {product}, due date {date}',
	关闭原因必填: 'Please enter a reason',
	关闭原因占位: 'Reason for closing, e.g. no longer needed, migrating away',
	核心: 'Core',
	恢复续费账单: 'Restore renewal bill',
	机房: 'Data center',
	'机房/线路': 'DC / route',
	计费: 'Billing',
	计价周期: 'Billing cycle',
	价格: 'Price',
	开通日期: 'Start date',
	'开通日期/到期日期': 'Start / expiry',
	'开通日期/结束日期': 'Start / end date',
	可选产品: 'Add-ons',
	可选线路: 'Available routes',
	控制台: 'Console',
	库存: 'Stock',
	库存不足无法下单: 'Out of stock, cannot place order',
	类型: 'Type',
	历史订单: 'History orders',
	密码: 'Password',
	名称: 'Name',
	默认带宽: 'Default bandwidth',
	默认内存: 'Default RAM',
	默认区域: 'Default region',
	默认数据盘: 'Default data disk',
	默认系统盘: 'Default system disk',
	默认CPU: 'Default vCPU',
	默认IP数量: 'Default IP count',
	内存: 'RAM',
	配置: 'Configuration',
	处理中: 'Processing',
	请填写关闭原因: 'Please provide a reason. A sales rep will follow up.',
	请至少改变一个配置: 'Please change at least one configuration',
	区域: 'Region',
	取消: 'Cancel',
	缺货: 'Out of stock',
	确认关闭编号为编号的订单: 'Close order <strong>{no}</strong>?',
	确认关闭订单提示: 'Submit a close request for order <strong>{no}</strong>? A sales rep will follow up.',
	'确认要到期不续费吗？': 'Confirm to not renew at expiration?',
	'确认要恢复续费账单吗？': 'Confirm to restore renewal bill?',
	申请已提交工单号: 'Ticket submitted, <strong>{no}</strong>',
	升级配置: 'Upgrade',
	生成发票: 'Renew',
	剩余: 'Available',
	试用开通日期: 'Trial start date',
	试用中: 'In trial',
	输入订单编号查询: 'Search by order number',
	数据盘: 'Data disk',
	刷新: 'Refresh',
	提交订单: 'Submit order',
	提示: 'Notice',
	网络: 'Network',
	未关联主机: 'No linked host',
	系统盘: 'System disk',
	下单时间: 'Order time',
	线路: 'Route',
	线路带宽: 'Route bandwidth',
	详情: 'Details',
	修改配置后生成: 'Generated after configuration changes',
	已启用: 'On',
	已失效: 'Expired',
	已停用: 'Off',
	硬盘: 'Disk',
	用户名: 'Username',
	远程端口: 'Remote port',
	月: 'Month',
	暂无可用线路: 'No routes available',
	支付: 'Pay bill',
	支付补差价: 'Pay difference',
	重置配置: 'Reset',
	主机名: 'Hostname',
	主机信息: 'Host information',
	状态: 'Status',
	字段不能小于原配置: '{field} cannot be lower than the original configuration',
	自定义: 'Custom',
	自动生成: 'Auto',
	自动续费: 'Auto renew',
	总计: 'Total',
	IP地址: 'IP address',
	IP配置: 'IP configuration',
	IP数量: 'IP count',
	IP数量限制: 'IP limit',
	MAC地址: 'MAC address',
	VPS信息: 'VPS info',
}
